import { type InventoryStatus } from '@/scripts/product/stoq-selling-plan'
import { updateAtcPreorderLabel } from '@/scripts/product/update-atc-status-label'

export type SubmitButtonState = {
	inventoryStatus: InventoryStatus
	available: boolean
	preorder: boolean
	inventoryStatusText: string
	priceInCents?: string | number | null
}

type SubmitButtonStateReader = () => SubmitButtonState

function updateFlatStatusLabel(labelEl: HTMLElement, state: SubmitButtonState) {
	if (state.inventoryStatus === 'InStock' || state.inventoryStatus === 'PreOrder') {
		updateAtcPreorderLabel(
			labelEl,
			state.inventoryStatusText,
			state.priceInCents
		)
		return
	}

	labelEl.textContent = state.inventoryStatusText
}

export function syncSubmitButtonLabel(
	button: HTMLButtonElement,
	state: SubmitButtonState
) {
	const inventoryStatusTextEl = button.querySelector<HTMLElement>(
		'[data-uc-inventory-status-text]'
	)
	const instockEl = button.querySelector<HTMLElement>(
		'[data-uc-inventory-status-instock]'
	)
	const outstockEl = button.querySelector<HTMLElement>(
		'[data-uc-inventory-status-outstock]'
	)
	const preorderEl = button.querySelector<HTMLElement>(
		'[data-uc-inventory-status-preorder]'
	)
	const comingSoonEl = button.querySelector<HTMLElement>(
		'[data-uc-inventory-status-comingsoon]'
	)

	if (instockEl && outstockEl && preorderEl && comingSoonEl) {
		if (state.preorder) {
			updateAtcPreorderLabel(
				preorderEl,
				state.inventoryStatusText,
				state.priceInCents
			)
		} else if (state.inventoryStatus === 'ComingSoon') {
			comingSoonEl.textContent = state.inventoryStatusText
		}

		instockEl.classList.toggle('hidden', state.inventoryStatus !== 'InStock')
		outstockEl.classList.toggle('hidden', state.inventoryStatus !== 'OutOfStock')
		preorderEl.classList.toggle(
			'hidden',
			state.inventoryStatus !== 'PreOrder'
		)
		comingSoonEl.classList.toggle(
			'hidden',
			state.inventoryStatus !== 'ComingSoon'
		)
	} else if (inventoryStatusTextEl) {
		updateFlatStatusLabel(inventoryStatusTextEl, state)
	}

	button.dataset.inventoryStatus = state.inventoryStatus
	button.dataset.preorder = String(state.preorder)
}

export function clearScheduledSubmitButtonLabelSync(button: HTMLButtonElement) {
	void button
}

export function scheduleSubmitButtonLabelSync(
	button: HTMLButtonElement,
	readState: SubmitButtonStateReader
) {
	syncSubmitButtonLabel(button, readState())
}
